var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-component-container"},[_c('span',{staticClass:"text-component-style",style:(`
      color:${_vm.text_color};
      font-size:${_vm.size}pt;
      font-weight:${_vm.font_weight};
      text-align:${_vm.align};
      line-height:${_vm.line_height};
      ${_vm.max_lines
        ? `display: -webkit-box;
          -webkit-line-clamp: ${_vm.max_lines};
          -webkit-box-orient: vertical;
          overflow: hidden;
          overflow-wrap: anywhere;`
        : ''
      }
      ${_vm.underlined ? 'text-decoration: underline;' : ''}
      ${_vm.strikethrough ? 'text-decoration: line-through;' : ''}`)},[(_vm.editable && _vm.text)?_c('input',{staticClass:"ttext-input",domProps:{"value":_vm.text},on:{"change":function($event){return _vm.$emit('changeValue', $event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return $event.target.blur()}}}):_c('div',[_vm._v(_vm._s(_vm.text_text))])]),(_vm.value && _vm.isEdit)?_c('button',{staticClass:"text-component-value-edit",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openLanguagePopUp()}}},[_c('TIcon',{attrs:{"name":"speech-bubble","dropshadow":"","size":"16"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }